module.exports = __webpack_public_path__ + "img/ch17_03_编号确认.5d23cc4d.jpg";